<!------------------------------

      Page Actions

------------------------------->

<ng-container *sbPageAction>
  <button
    *ngPermissions="permissionService.Permission.template_source_create"
    type="button"
    sb-button-primary
    [color]="'green'"
    [icon]="'plus'"
    [loading]="loading()"
    [iconButton]="true"
    (click)="createTemplateSource()"
    sbTooltip="{{ 'lang.globals.templateSources.create' | translate }}"
  >
  </button>

  <button
    type="button"
    sb-button-primary
    color="blue"
    sbTooltip="{{ 'lang.globals.refresh' | translate }}" placement="top"
    container="body"
    [iconButton]="true"
    [icon]="'refresh'"
    (click)="requestDebounced()"
    [disabled]="loading()"
    [loading]="loading()">
  </button>

</ng-container>


<!------------------------------

    Table wrapper

------------------------------->
<sb-table-wrapper-new
  headline="{{'lang.globals.templateSources' | translate}}"
  [isInModalContext]="isInModalContext"
  [itemsData]="templateSources"
  (paginationChange)="requestDebounced($event)"
  [loading]="loading()"
  [itemName]="'templateSources'">

  <!------------------------------

    Filter Panel

------------------------------->

  <div filter-panel class="tw-bg-[#F8F9FC] dark:tw-bg-sbGray-930 tw-rounded-l-xl">
    <sb-filter-panel
      #FilterPanelRef
      (filterChange)="applyFiltering($event)"
      [headerClasses]="'tw-bg-sbGray-50 dark:tw-bg-sbGray-930 tw-border-solid tw-border-0 tw-z-40 tw-border-b tw-border-sbGray-500 dark:tw-border-sbGray-50 tw-h-[60px] tw-rounded-tl-xl'"
      [config]="filterConfig"
      filterID="search"
    >

      <sb-filter-section *ngPermissions="permissionService.Permission.template_group_list"
                         title="{{'lang.globals.areaCategories' | translate}}"
                         icon="templates">
        <sb-filter-dto-list-select filterID="templateGroups" [endpoint]="api.mm_templating_provider_TemplateGroup_retrieveAll.bind(api)">
        </sb-filter-dto-list-select>
      </sb-filter-section>

    </sb-filter-panel>
  </div>
  <!------------------------------

        Table Header

  ------------------------------->
  <ng-template #thead>
    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.templateGroup' | translate }}
      </th>
      <th class=" sticky-col last-col">
        {{ 'lang.globals.action' | translate }}
      </th>
    </tr>
  </ng-template>
  <!------------------------------

  Table Body

------------------------------->
  <ng-template #tbody let-data>

    <tr>
      <td>
        {{ data?.id }}
      </td>
      <td>
        @if (!isInModalContext && permissionService.hasPermission(permissionService.Permission.template_source_entry_list)) {
          <sb-comp-link
            [title]="data?.name"
            [link]="util.RoutingID.templateSourceEntries"
            [pathParams]="[{id: 'templateSourceID', value: data?.id}]"
            [tooltip]="'lang.globals.templateSourceEntries.show' | translate">
          </sb-comp-link>
        } @else {
          <span class="font-weight-bold">
            {{ data?.name }}
          </span>
        }
      </td>
      <td>
        <sb-comp-link
          [title]="data?.templateGroup?.name"
          [condition]="!isInModalContext"
          [permission]="permissionService.Permission.template_group_list"
          [link]="util.RoutingID.templateGroup"
          [pathParams]="[{id: 'templateGroupID',value: data?.templateGroup.id}]"
          [tooltip]="'lang.globals.templateGroup' | translate">
        </sb-comp-link>
      </td>
      <td class="sticky-col last-col">
        @if (isInModalContext) {
          <button
            sb-button-secondary
            [iconButton]="true"
            [color]="'blue'"
            [icon]="'boxChecked'"
            [ngbTooltip]="'lang.globals.select' | translate"
            (click)="selectTemplateSource(data)">
          </button>
        } @else {
          <sb-split-button
            [splitButtonItems]="data.sbButtons ?? []"
          ></sb-split-button>
        }
      </td>
    </tr>
  </ng-template>

</sb-table-wrapper-new>
